import React, { FC, useEffect, useRef } from 'react'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import 'videojs-youtube'

import * as SC from './styled'

export type MediaProps = {
  mediaType: 'image' | 'video'
  src: string
  alt?: string
  poster?: string // Ajout du poster
  className?: string
}

const DEFAULT_POSTER = 'static/images/onboarding/thumbnail.jpg'

const MediaComponent: FC<MediaProps> = ({ mediaType, src, alt, poster, className }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const playerRef = useRef<any | null>(null)

  useEffect(() => {
    if (mediaType === 'video' && videoRef.current) {
      const options: any = {
        techOrder: ['youtube', 'html5'],
        sources: [
          {
            src: src,
            type:
              src.includes('youtube.com') || src.includes('youtu.be')
                ? 'video/youtube'
                : 'video/mp4',
          },
        ],
        youtube: {
          modestbranding: 1,
          rel: 0,
        },
        controls: true,
        responsive: true,
        fluid: true,
        fill: true, // Remplit le conteneur
      }

      playerRef.current = videojs(videoRef.current, options)

      return () => {
        if (playerRef.current) {
          playerRef.current.dispose()
          playerRef.current = null
        }
      }
    }
  }, [mediaType, src])

  return (
    <SC.Container className={className}>
      <SC.StyledMedia>
        {mediaType === 'image' ? (
          <img src={src} alt={alt || 'media'} />
        ) : (
          <div data-vjs-player>
            <video
              ref={videoRef}
              className="video-js vjs-default-skin"
              controls
              poster={poster || DEFAULT_POSTER} // Poster par défaut
            />
          </div>
        )}
      </SC.StyledMedia>
    </SC.Container>
  )
}

export default MediaComponent
